export const colorPalet = ['#2e9699', '#3da797', '#5cb88e', '#84c681', '#b1d175', ' #c9c661', ' #e0b856', '#f5a956', '#ef8453', '#e05f59']

export function SelectColor(percent) {
    if(percent >= 90)
        return colorPalet[0]
    if(percent < 90 && percent >= 70)
        return colorPalet[1]
    if(percent < 70 && percent >= 60)
        return colorPalet[2]
    if(percent < 60 && percent >= 50)
        return colorPalet[4]
    if(percent < 50 && percent >= 40)
        return colorPalet[5]
    if(percent < 40 && percent >= 30)
        return colorPalet[6]
    if(percent < 30 && percent >= 20)
        return colorPalet[7]
    if(percent < 20 && percent >= 10)
        return colorPalet[8]
    if(percent < 10)
        return colorPalet[9]
}